module.exports = __webpack_public_path__ + "static/media/mighty-finger.7e9407e0.png";